// ---------------------------------------------- modules import
import { AlbumAction, AlbumActionType } from "./common";

// ---------------------------------------------- action creators
class Actions {
  static addBegin = (): AlbumAction => ({
    type: AlbumActionType.ADD_ALBUM_BEGIN
  });

  static addSuccess = (): AlbumAction => ({
    type: AlbumActionType.ADD_ALBUM_SUCCESS
  });

  static addError = (error: string): AlbumAction => ({
    type: AlbumActionType.ADD_ALBUM_ERROR,
    payload: {
      error
    }
  });

  static updateBegin = (): AlbumAction => ({
    type: AlbumActionType.UPDATE_ALBUM_BEGIN
  });

  static updateSuccess = (): AlbumAction => ({
    type: AlbumActionType.UPDATE_ALBUM_SUCCESS
  });

  static updateError = (error: string): AlbumAction => ({
    type: AlbumActionType.UPDATE_ALBUM_ERROR,
    payload: {
      error
    }
  });

  static deleteBegin = (): AlbumAction => ({
    type: AlbumActionType.DELETE_ALBUM_BEGIN
  });

  static deleteSuccess = (): AlbumAction => ({
    type: AlbumActionType.DELETE_ALBUM_SUCCESS
  });

  static deleteError = (error: string): AlbumAction => ({
    type: AlbumActionType.DELETE_ALBUM_ERROR,
    payload: {
      error
    }
  });
}

export default Actions;
